export enum Vertical {
  Banking = 'banking',
  Investing = 'investing',
  Retirement = 'retirement',
  Ria = 'ria',
  Taxes = 'taxes',
  // Used for financial advisors breadcrumbs, to be removed when migrated
  FinancialAdvisors = 'financial_advisors',
}

export const VERTICAL_DISPLAY_NAMES: Record<string, string> = {
  [Vertical.FinancialAdvisors]: 'Financial Advisors',
  [Vertical.Investing]: 'Investing',
  [Vertical.Retirement]: 'Retirement',
  [Vertical.Taxes]: 'Taxes',
};

export const VERTICAL_URL_PATHS: Record<string, string> = {
  [Vertical.FinancialAdvisors]: 'financial-advisors',
  [Vertical.Investing]: 'investing',
  [Vertical.Retirement]: 'retirement',
  [Vertical.Taxes]: 'taxes',
};

export enum MarketplaceProductTypeEnum {
  Banking = 'BANKING',
  Investing = 'INVESTING',
  Retirement = 'RETIREMENT',
}

export enum InvestingReviewPrimaryCategory {
  Advisors = 'advisors',
  Brokers = 'brokers',
}

export const STATES_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const allStates = Object.keys(STATES_MAP) as (keyof typeof STATES_MAP)[];
